import type { SendContactFormResult } from '../../domain/models/send-contact-form-result';

export class SendContactFormResultViewModel {
  constructor() {}

  static presenter(_result: SendContactFormResult): SendContactFormResultViewModel {
    return new SendContactFormResultViewModel();
  }
}
